<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <i class="myfont icon-tongzhi"></i>
      <span class="font-20">通知通告</span>
    </div>
    
    <div class="pt10">
      <div class="item" v-for="(item, index) in list" :key="index">
        <a class="block app-item" :class="item.read ? 'read' : ''" :href="item.url" target="_blank">
          <img class="app-img" :src="item.appIcon ? item.appIcon : `${baseUrl}images/notice.png`" width="60" height="60" slot="error">
          <div class="item-con">
            <el-tooltip placement="top" effect="light">
              <div slot="content">{{ item.name }}</div>
              <p class="ellipsis">{{ item.name }}</p>
            </el-tooltip>
          </div>
        </a>
      </div>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无通知通告</el-col>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardNotice",
  components: {},
  props: ["w", "h"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchList();
  },
  destroyed() {},
  methods: {
    fetchList () {
      this.loading = true;
      setTimeout(() => {
        let data = [
          { id: "1", read: false, appIcon: '', name: "迈越人风采 | 为南宁市青年志愿者黄艺点赞！", url: "http://www.maiyuesoft.com/info/1014/1469.htm" },
          { id: "2", read: false, appIcon: '', name: "迈越公司2月17日起正式复工！", url: "http://www.maiyuesoft.com/info/1014/1468.htm" },
          { id: "3", read: false, appIcon: '', name: "师生健康-教育疫情信息采集平台进入“爱广西”APP啦！", url: "http://www.maiyuesoft.com/info/1014/1467.htm" },
          { id: "4", read: false, appIcon: '', name: "迈越公司参加“自治区非公有制经济工作领导小组办公室2020年第一次会议“做好疫情防控和复工复产工作", url: "http://www.maiyuesoft.com/info/1014/1466.htm" },
          { id: "5", read: false, appIcon: '', name: "迈越软件祝大家元宵节快乐、心想事成", url: "http://www.maiyuesoft.com/info/1014/1465.htm" },
          { id: "6", read: false, appIcon: '', name: "每日打卡报平安|迈越疫情信息采集系统上线啦！", url: "http://www.maiyuesoft.com/info/1014/1464.htm" },
          { id: "7", read: false, appIcon: '', name: "迈越公司积极响应党和政府号召坚决配合打赢疫情防控狙击战", url: "http://www.maiyuesoft.com/info/1014/1463.htm" },
          { id: "8", read: false, appIcon: '', name: "感恩有你，一路同行 | 2019年度迈越&华为客户团拜会", url: "http://www.maiyuesoft.com/info/1014/1454.htm" },
          { id: "9", read: false, appIcon: '', name: "迈越公司受邀参加河池学院校企协同育人基地学生团队年终总结表彰会", url: "http://www.maiyuesoft.com/info/1014/1453.htm" },
          { id: "10", read: false, appIcon: '', name: "聚力信息化·共筑同心圆 | 迈越公司受邀参加“广西信息化发展组织联合会2019年工作年会”", url: "http://www.maiyuesoft.com/info/1014/1451.htm" },
          { id: "11", read: false, appIcon: '', name: "迈越公司受邀参加2020年广西民营企业迎春茶话会", url: "http://www.maiyuesoft.com/info/1014/1450.htm" },
          { id: "12", read: false, appIcon: '', name: "迈越公司受邀参加广西解决民营企业突出问题百日攻坚行动推进会", url: "http://www.maiyuesoft.com/info/1014/1425.htm" }
        ];

        data.forEach( (e, index) => {
          if (this.h > 1 ) {
            // 大过1 的时候，加上标题占的高度
            if ( index < (this.h * 5 + this.h)) {
              this.list.push(e)
            }
          } else {
            if ( index < (this.h * 5)) {
              this.list.push(e)
            }
          }
        })

        this.loading = false;
      }, 500)
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .card-title {
    height: 40px;
  }

  .card-title i {
    color: #619df8;
    font-size: 20px;
    margin-left: 10px;
    margin-right: 5px;
  }

  .item {
    padding: 5px 10px;
  }

  .app-item {
    display: flex;
    flex-direction: row;
    padding: 10px;
    background-color: #f6f6f6;
  }
  
  .app-img {
    width: 24px;
    height: 24px;
  }
  
  .app-item.read {
    position: relative;
  }
  
  .app-item.read::before {
    width: 4px;
    height: 4px;
    content: '';
    background: red;
    border-radius: 50%;
    position: absolute;
    top: 8px;
    left: 30px;
  }

  .item-con {
    flex: 1;
    width: 100%;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
  }
  
  .item-con p {
    width: 80%;
    text-align: left;
  }
</style>
